import React, { useState } from "react";
import "./BookingHistory.css";
import "./BookingList.css";
import { FaArrowRight } from "react-icons/fa";

function BookingList() {
  const [activeTab, setActiveTab] = useState("All");

  // Sample booking data
  const bookings = [
    {
      id: 1,
      name: "John Doe",
      time: "10:30 AM",
      status: "Confirmed",
      date: "2025-09-01",
      tour: "Colombo City Tour",
    },
    {
      id: 2,
      name: "Sophia Smith",
      time: "2:00 PM",
      status: "Rejected",
      date: "2025-09-05",
      tour: "Kandy Temple Visit",
    },
    {
      id: 3,
      name: "Michael Brown",
      time: "11:00 AM",
      status: "Confirmed",
      date: "2025-09-10",
      tour: "Sigiriya Rock Tour",
    },
  ];

  const filteredBookings =
    activeTab === "All"
      ? bookings
      : bookings.filter((b) =>
        activeTab === "Completed"
          ? b.status === "Confirmed"
          : b.status === "Rejected"
      );

  // Helper to format date
  const formatDate = (dateString) => {
    const dateObj = new Date(dateString);
    const day = dateObj.getDate();
    const month = dateObj.toLocaleString("default", { month: "short" }); // e.g., Sep
    return { day, month };
  };

  return (
    <div className="booking-history-container">
      <h2 className="booking-title">Booking List</h2>

      {/* Tabs */}
      <div className="booking-tabs">
        {["All", "Completed", "Cancelled"].map((tab) => (
          <button
            key={tab}
            className={`tab-btn ${activeTab === tab ? "active" : ""}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Booking List */}
      <div className="booking-wrapper">
        {filteredBookings.map((booking) => {
          const { day, month } = formatDate(booking.date);

          return (
            <div key={booking.id} className="booking-card-row">
              {/* Date Box */}
              <div className="booking-date-box">
                <span className="date-day">{day}</span>
                <span className="date-month">{month}</span>
              </div>

              {/* Booking Details */}
              <div className="booking-details">
                <p className="booking-name">{booking.name}</p>
                <p className="booking-tour">{booking.tour}</p>
                <p className="booking-time">{booking.time}</p>
                {/* Use dynamic class based on status */}
                <span
                  className={`booking-status status-${booking.status}`}
                >
                  {booking.status}
                </span>
              </div>

              {/* Action Button */}
              <div className="booking-actions">
                <button className="booking-btn">
                  <FaArrowRight />
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default BookingList;
